var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExclamationTriangle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "#F5C108",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13.2998,
    y: 9.59998,
    width: 6.4,
    height: 14.4,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.397 4.56346L3.90304 23.6434C3.02332 25.2429 4.18051 27.2 6.00596 27.2H26.9939C28.8193 27.2 29.9765 25.2429 29.0968 23.6434L18.6028 4.56346C17.691 2.9056 15.3088 2.90561 14.397 4.56346ZM16.4999 10.8C17.1626 10.8 17.6999 11.3373 17.6999 12V18.4C17.6999 19.0628 17.1626 19.6 16.4999 19.6C15.8372 19.6 15.2999 19.0628 15.2999 18.4V12C15.2999 11.3373 15.8372 10.8 16.4999 10.8ZM17.6999 22C17.6999 22.6628 17.1626 23.2 16.4999 23.2C15.8372 23.2 15.2999 22.6628 15.2999 22C15.2999 21.3373 15.8372 20.8 16.4999 20.8C17.1626 20.8 17.6999 21.3373 17.6999 22Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationTriangle);
export default __webpack_public_path__ + "static/media/exclamation-triangle.67d10f8c.svg";
export { ForwardRef as ReactComponent };